import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { DateTime } from 'luxon';

import { setToken } from '../actions/authenticationContext.actions';
import { forgeAccessTokenExpiration, forgeRefreshTokenCookie } from '../types';
import { setCookie } from '../utils/cookies';
import setAuthToken from '../utils/setAuthToken';

export type ForgeTokenUpdatedPayload = {
	access_token: string;
	refresh_token: string;
	expires_in?: number;
};

export default function useForgeTokenSyncFromWorker() {
	const dispatch = useDispatch();

	return useCallback(
		(data: ForgeTokenUpdatedPayload): void => {
			const expiresTimeInSeconds = data.expires_in ?? 120;
			const expirationInMinutes = Math.max(
				1,
				Math.floor(Number(expiresTimeInSeconds || 0) / 60),
			);

			setAuthToken(data.access_token, expirationInMinutes);

			const twoWeeksInMinutes = 60 * 24 * 13;
			setCookie(
				forgeRefreshTokenCookie,
				data.refresh_token,
				twoWeeksInMinutes,
			);

			const accessTokenExpirationDate =
				DateTime.now().plus({ minutes: expirationInMinutes }).toISO() ??
				'';
			setCookie(
				forgeAccessTokenExpiration,
				accessTokenExpirationDate,
				expirationInMinutes,
			);

			dispatch(setToken(data.access_token));
		},
		[dispatch],
	);
}
